/* ==========================================================================
   ARTQO BLOG 記事内データチャート（ECharts）
   --------------------------------------------------------------------------
   本文の <div class="rw-chart" data-chart="market-total"></div> に
   <script type="application/json" class="rw-chart__data"> の JSON を
   対にして置くと、このスクリプトが ECharts で描画する。

   書式:
     <div class="rw-chart" data-chart="market-total">
       <div class="rw-chart__head">
         <p class="rw-chart__title">タイトル<span class="rw-chart__unit">単位</span></p>
       </div>
       <div class="rw-chart__canvas"></div>
       <p class="rw-chart__note">注記</p>
       <script type="application/json" class="rw-chart__data">
         {"type":"barLine","x":["2020","2021"],"series":[{"name":"売上","data":[1,2]}]}
       </script>
     </div>
   ========================================================================== */

(function () {
  var SRC = 'https://cdn.jsdelivr.net/npm/echarts@5.5.0/dist/echarts.min.js';
  var INK = '#2a251e';
  var SOFT = '#5d5548';
  var FAINT = '#8a8174';
  var LINE = '#e7dfcf';
  var WOOD = '#a9764a';
  var MOSS = '#4e6e58';
  var SERIES_COLORS = [WOOD, MOSS, '#8b6f4e', '#b08d57', '#5f7a6b', '#a9764a'];

  function el(tag, cls) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    return e;
  }

  function ensureCanvas(host) {
    var c = host.querySelector('.rw-chart__canvas');
    if (!c) {
      c = el('div', 'rw-chart__canvas');
      var head = host.querySelector('.rw-chart__head');
      if (head) head.parentNode.insertBefore(c, head.nextSibling);
      else host.appendChild(c);
    }
    return c;
  }

  function axisBase(extra) {
    var o = {
      axisLine: { lineStyle: { color: LINE } },
      axisTick: { show: false },
      axisLabel: { color: FAINT, fontSize: 11 }
    };
    if (extra) for (var k in extra) o[k] = extra[k];
    return o;
  }

  function buildOption(cfg) {
    var type = cfg.type || 'bar';
    var x = cfg.x || [];
    var series = cfg.series || [];
    var opt = {
      color: SERIES_COLORS,
      series: [],
      textStyle: { fontFamily: 'Yu Gothic, Hiragino Kaku Gothic ProN, Meiryo, sans-serif' },
      grid: { left: 8, right: 16, top: 28, bottom: 6, containLabel: true },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        backgroundColor: 'rgba(42,37,30,.94)',
        borderWidth: 0,
        textStyle: { color: '#fff', fontSize: 12 },
        valueFormatter: function (v) {
          return cfg.unit ? v + ' ' + cfg.unit : v;
        }
      },
      legend: series.length > 1 ? {
        top: 0,
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 16,
        textStyle: { color: SOFT, fontSize: 11 }
      } : { show: false }
    };

    if (type === 'barLine') {
      opt.xAxis = { type: 'category', data: x, axisTick: { show: false }, axisLine: { lineStyle: { color: LINE } }, axisLabel: { color: FAINT, fontSize: 11 } };
      opt.yAxis = [
        axisBase({ type: 'value', name: cfg.leftName, nameTextStyle: { color: FAINT, fontSize: 11, align: 'right' }, splitLine: { lineStyle: { color: LINE, type: 'dashed' } } }),
        axisBase({ type: 'value', name: cfg.rightName, nameTextStyle: { color: FAINT, fontSize: 11 }, splitLine: { show: false } })
      ];
      series.forEach(function (s, i) {
        if (i === 0) {
          opt.series.push({
            name: s.name, type: 'bar', data: s.data, barMaxWidth: 38,
            itemStyle: { borderRadius: [3, 3, 0, 0] },
            yAxisIndex: 0
          });
        } else {
          opt.series.push({
            name: s.name, type: 'line', data: s.data, yAxisIndex: 1,
            smooth: true, symbol: 'circle', symbolSize: 6,
            connectNulls: false,
            lineStyle: { width: 2.5 },
            label: {
              show: true, position: 'top', color: SOFT, fontSize: 11,
              formatter: function (p) { return p.value == null ? '' : p.value + '%'; }
            }
          });
        }
      });
      return opt;
    }

    if (type === 'pie') {
      opt.tooltip = {
        trigger: 'item',
        backgroundColor: 'rgba(42,37,30,.94)',
        borderWidth: 0,
        textStyle: { color: '#fff', fontSize: 12 },
        formatter: '{b}<br/>{c} ({d}%)'
      };
      opt.legend = {
        bottom: 0,
        itemWidth: 12, itemHeight: 12, itemGap: 14,
        textStyle: { color: SOFT, fontSize: 11 }
      };
      opt.series.push({
        type: 'pie',
        radius: ['46%', '72%'],
        center: ['50%', '44%'],
        avoidLabelOverlap: true,
        itemStyle: { borderColor: '#fff', borderWidth: 2 },
        label: {
          show: true, color: SOFT, fontSize: 11,
          formatter: '{b}\n{d}%'
        },
        labelLine: { length: 10, length2: 10, lineStyle: { color: LINE } },
        data: series[0].data.map(function (d, i) {
          return { name: d.name, value: d.value, itemStyle: { color: SERIES_COLORS[i % SERIES_COLORS.length] } };
        })
      });
      return opt;
    }

    // bar（横棒）
    opt.xAxis = { type: 'value', axisLabel: { color: FAINT, fontSize: 11 }, splitLine: { lineStyle: { color: LINE, type: 'dashed' } } };
    opt.yAxis = {
      type: 'category',
      data: x,
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: { color: SOFT, fontSize: 12 }
    };
    opt.grid = { left: 8, right: 40, top: 12, bottom: 6, containLabel: true };
    opt.series.push({
      type: 'bar',
      data: series[0].data.map(function (v, i) {
        return { value: v, itemStyle: { color: SERIES_COLORS[i % SERIES_COLORS.length], borderRadius: [0, 3, 3, 0] } };
      }),
      barMaxWidth: 22,
      label: { show: true, position: 'right', color: SOFT, fontSize: 11, formatter: '{c}%' }
    });
    return opt;
  }

  function readConfig(host) {
    // データは <div class="rw-chart__data" data-json="{...}"> に置く。
    // （<script type="application/json"> は Shopify のリHugo処理で
    //   実行されてしまい、ページ全体で JS エラーになるため使わない）
    var el = host.querySelector('.rw-chart__data');
    if (!el) return null;
    var raw = el.getAttribute('data-json');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function renderAll() {
    if (typeof window.echarts === 'undefined') return;
    var hosts = document.querySelectorAll('.rw-chart[data-chart]');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      if (host.getAttribute('data-rw-charted') === '1') continue;
      var cfg = readConfig(host);
      if (!cfg) continue;
      var canvas = ensureCanvas(host);
      host.classList.remove('is-loading');
      var chart = window.echarts.init(canvas, null, { renderer: 'canvas' });
      chart.setOption(buildOption(cfg));
      host.setAttribute('data-rw-charted', '1');
      (function (h, c) {
        window.addEventListener('resize', function () { c.resize(); });
        if (window.ResizeObserver) {
          new ResizeObserver(function () { c.resize(); }).observe(h);
        }
      })(host, chart);
    }
  }

  function boot() {
    var hosts = document.querySelectorAll('.rw-chart[data-chart]');
    if (!hosts.length) return;
    for (var i = 0; i < hosts.length; i++) hosts[i].classList.add('is-loading');

    function start() {
      renderAll();
    }

    if (typeof window.echarts !== 'undefined') { start(); return; }

    // ECharts をCDN から読み込む
    var s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    s.onload = start;
    s.onerror = function () {
      for (var i = 0; i < hosts.length; i++) hosts[i].classList.remove('is-loading');
    };
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
